import {useRouteMatch} from "react-router-dom";
import { PdfReadySignal } from "./components/pdfReadySignal";
import {LaegekompetenceMeta} from "../../sharedmodels/kompetence/laegekompetenceMeta";
import {useEffect, useState} from "react";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {LaegekompetenceStatusEnum} from "../../sharedmodels/kompetence/laegekompetenceStatusEnum";
import PdfComponent from "core/components/pdf/components/pdfComponent";
import {PdfKompetenceHeaderComponent} from "./pdfHeaders/pdfKompetenceHeaderComponent";
import {useFetchWithErrorHandlingPdf} from "./hooks/useFetchWithErrorHandlingPdf";
import useLogbogApi from "../../hooks/useLogbogApi";
import IdAndModelsContainer from "core/sharedmodels/containers/IdAndModelsContainer";
import { GenericIdPath } from "infrastructure/route/routePathConstants";
import PdfRow from "./components/pdfRow";
import HtmlHeading from "../titels/HtmlHeadings";
import React from "react";
import { fetchKompetenceHeader, fetchKompetenceHeadersMap, KompetenceHeaderApis } from "./helpers/pdfFetchers";
import { PdfKompetenceHeaderModel } from "./models/pdfKompetenceHeaderModel";
import useStamdataApi from "core/hooks/useStamdataApi";

type Container = IdAndModelsContainer<LaegekompetenceMeta>;

export const AllKompetencerOnUserPdf = () => {

    const { notatApi, logbogLaegeKompetenceApi, forloebApi, logbogUserInfoApi } = useLogbogApi();
    const { stamdataMaalbeskrivelseApi, stamdataSpecialeApi } = useStamdataApi();

    const params = useRouteMatch<GenericIdPath>().params;
    const userId = params.id;

    const [containers, setContainers] = useState<Container[]>([]);
    const [headerDataMap, setHeaderDataMap] = useState<Map<string, PdfKompetenceHeaderModel>>(new Map());
    const [dataLoaded, setDataLoaded] = useState(false);

    const setError = useFetchWithErrorHandlingPdf();

    useEffect(() => {
        if(userId === undefined || userId === "") return;

        const fetchData = async () =>  {
            const pdfKompetenceApis: KompetenceHeaderApis = { stamdataMaalbeskrivelseApi, stamdataSpecialeApi, logbogUserInfoApi}

            const containers = await logbogLaegeKompetenceApi.getLaegekompetencerForPDfByBrugerId(userId);

            const headerDataMap = await fetchKompetenceHeadersMap(userId, containers.map(c => c.id), pdfKompetenceApis);
            return {containers, headerDataMap};
        }
        fetchData()
            .then(({containers, headerDataMap}) => {
                setContainers(containers);
                setHeaderDataMap(headerDataMap);
                setDataLoaded(true);
            })
            .catch(err => setError(err));

    }, [forloebApi, logbogLaegeKompetenceApi, notatApi, setError, userId]);

    return (
        <PdfComponent>

            {containers.length > 0 && containers.map(({id: brugerMaalbeskrivelseId, models: laegeKompetencer}, i) => (
                <PdfComponent.PageBreakAfter key={brugerMaalbeskrivelseId}>
                    {/* Note: The below code is taken from "KompetencerPdf.tsx" - make sure changes are made in both files. Maybe move to shared component in the future */}
                    {headerDataMap.get(brugerMaalbeskrivelseId) && (
                        <PdfKompetenceHeaderComponent
                            brugerId={userId}
                            data={headerDataMap.get(brugerMaalbeskrivelseId)!}
                        />
                    )}

                    <PdfComponent.BlockItem className={"card shadow-none"}>
                        <PdfComponent.CardHeader>
                            <PdfRow className="flex-fill padding-top-m padding-bottom-m" useFlex={false}>
                                <PdfRow.Col heading={HtmlHeading.H3} width={6}>{Localizer.global_kompetencer()}</PdfRow.Col>
                                <PdfRow.Col heading={HtmlHeading.H3} width={2}>{Localizer.global_status()}</PdfRow.Col>
                                <PdfRow.Col heading={HtmlHeading.H3} width={4}>{Localizer.global_godkendtAf()}</PdfRow.Col>
                            </PdfRow>
                        </PdfComponent.CardHeader>
                        <PdfComponent.CardBody additionalClasses="padding-top-0">
                            <div className={"card-list-modal"}>
                                {laegeKompetencer?.map((laegekompetence, index) =>
                                    <React.Fragment key={index}>
                                        <PdfComponent.NonBreakableItem key={index}>
                                            <PdfRow useFlex={false} alignTop={false} className="margin-top-s margin-bottom-s">
                                                <PdfRow.Col width={6} className={"flex-align-c"}>
                                                    <div className="flex-row">
                                                        <div className="subtle">
                                                            {laegekompetence.kompetenceNummer} <br/> {laegekompetence.fullKompetenceTitle}
                                                        </div>
                                                    </div>

                                                </PdfRow.Col>
                                                <PdfRow.Col width={2} className={"flex-align-c"}>
                                                    {laegekompetence.godkendtDato &&
                                                        <>
                                                            {laegekompetence.meritNotat !== null &&
                                                                <div className={"flex-row"}>
                                                                    <div>{Localizer.godkendtMedMeritDen() +": "}</div>
                                                                    <div>{new Date(laegekompetence.godkendtDato).dateWithTimeFormat()}</div>
                                                                    <div>{laegekompetence.meritNotat}</div>
                                                                </div>
                                                            }
                                                            {laegekompetence.meritNotat === null &&
                                                                <div className={"flex-row"}>
                                                                    <div>{Localizer.godkendtDen() +": "}</div>
                                                                    <div>{new Date(laegekompetence.godkendtDato).dateWithTimeFormat()}</div>
                                                                </div>
                                                            }

                                                        </>

                                                    }
                                                    {!laegekompetence.godkendtDato && laegekompetence.status != LaegekompetenceStatusEnum.Klarmeldt &&
                                                        <> {Localizer.global_ikkeGodkendt()} </>
                                                    }
                                                    {laegekompetence.status === LaegekompetenceStatusEnum.Klarmeldt &&
                                                        <> {Localizer.global_klarmeldt()} </>
                                                    }
                                                </PdfRow.Col>
                                                <PdfRow.Col width={4} className={"flex-align-c"}>
                                                    {laegekompetence.godkendtAfNavn &&
                                                        <div>
                                                            {`${Localizer.global_name()}: ${laegekompetence.godkendtAfNavn}`}

                                                            {laegekompetence.godkendtAfAuthId &&
                                                                <div className={"flex-container"}>
                                                                    <div className={"padding-right-xs"}>{`${Localizer.global_authorisationId()}:`}</div>
                                                                    <div>{laegekompetence.godkendtAfAuthId}</div>
                                                                </div>
                                                            }
                                                            <div className={"flex-container"}>
                                                                <div className={"padding-right-xs"}>{`${Localizer.rolle()}:`}</div>
                                                                <div>{laegekompetence.godkendtAfRolleTitel}</div>
                                                            </div>
                                                        </div>
                                                    }
                                                </PdfRow.Col>
                                            </PdfRow>
                                        </PdfComponent.NonBreakableItem>
                                        <div className={"card-list-border"}/>
                                    </React.Fragment>
                                )}
                            </div>
                        </PdfComponent.CardBody>
                    </PdfComponent.BlockItem>

                    <PdfComponent.PageBreak/>
                </PdfComponent.PageBreakAfter>

            ))}
            <PdfReadySignal when={dataLoaded} />
        </PdfComponent>
    );
}
